import { render, staticRenderFns } from "./vPuestoAproba.vue?vue&type=template&id=7541015c&scoped=true&"
import script from "./vPuestoAproba.vue?vue&type=script&lang=js&"
export * from "./vPuestoAproba.vue?vue&type=script&lang=js&"
import style0 from "./vPuestoAproba.vue?vue&type=style&index=0&id=7541015c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541015c",
  null
  
)

export default component.exports